package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.FeedbackRequest

class FeedbackRepository(private val httpClient: HttpClient) {
    suspend fun send(req: FeedbackRequest): Result<Unit> = runCatching {
        val response = httpClient.post("feedback") {
            contentType(ContentType.Application.Json)
            setBody(req)
        }
        if (!response.status.isSuccess()) {
            throw IllegalStateException("Feedback request failed with status ${response.status.value}")
        }
    }
}
